import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import StartAltBtn from './StartAltBtn'

export default class LandingPageBtnRow extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    const btnStyle = {
      height: '100%',
      width: '100%',
      maxHeight: 197,
      maxWidth: 301,
      zIndex: 50
    }

    return (
      <div>
        <Col xs={1} />
        <Col xs={9} sm={5} md={4} lg={3}>
          <StartAltBtn btnStyle={btnStyle} />
        </Col>
        {/* <Col xs={6} sm={5} md={4} lg={3}>
          <StartBtn btnStyle={btnStyle} />
        </Col> */}
        <Col xs={1} md={3} lg={5} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/LandingPageBtnRow.js